import { DataStore } from "@xbs/muon";
import { IAction, IActionConfig, SpreadsheetEvents } from "../types";

export class DeleteSheet implements IAction {
	public config: IActionConfig;
	private _index: number;
	private _data: any;
	private _sheetMeta: any;
	private _store: DataStore;
	private _deletedSheet: any;

	constructor(config: IActionConfig) {
		this.config = config;
		this._store = config.dataStore;
		this._deletedSheet ={ ...config.sheets.getItem(config.prev)};
	}

	do() {
		const { sheets, spreadsheet, val } = this.config;
		const page = this._store.getPage(val);

		this._data = page ? page.serialize(true) : [];
		this._sheetMeta = page ? page.getMeta() : {};
		this._store.removePage(val);
		const index = (this._index = sheets.getIndex(this._deletedSheet.id));
		if (val === spreadsheet.getActiveSheet().name) {
			(spreadsheet as any)._changeSheet(sheets.getId(index === 1 ? index + 1 : index - 1));
		}

		sheets.remove(this._deletedSheet.id);
		this.config.grid.paint();
	}

	undo() {
		const { sheets, spreadsheet, val } = this.config;
		this._store.addPage(val);
		sheets.add(this._deletedSheet, this._index);
		const page = this._store.getPage(val);
		page.setMeta(this._sheetMeta);
		page.parse(this._data);
		this._store.getStore().recalculate(true, page.getContext());
		(spreadsheet as any)._changeSheet(this._deletedSheet.id);
		this.config.grid.paint();
	}
}
